import React from 'react';
import PropTypes from 'prop-types';
import CourseProp from '../propTypes/courseProp';
import translate from '../../../commonComponents/translate';

function CourseContinueButton({ t, course, onClick }) {
  if (course.progress >= 100) {
    return null;
  }

  const buttonText = course.progress > 0 ? t('continue') : t('start');
  return (
    <button
      type="button"
      className="btn m-btn--pill btn-dynamic"
      onClick={onClick}
    >
      {buttonText}
    </button>
  );
}

CourseContinueButton.propTypes = {
  t: PropTypes.func.isRequired,
  course: PropTypes.shape(CourseProp.propType).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default translate(CourseContinueButton);
